import React from 'react';

import { requiredFieldArrayCheckbox } from '../../../util/validators';
import { FieldCheckboxGroup } from '../../../components';

import { intlShape } from '../../../util/reactIntl';

import css from './UsEligibilityCertification.module.css';

/**
 * A component that renders the US citizenship/location certification checkbox shown to vendors
 * during signup. Vendor accounts can only be created after this box is checked.
 *
 * @component
 * @param {Object} props
 * @param {string} props.formId - The form id
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const UsEligibilityCertification = props => {
  const { formId, intl } = props;

  return (
    <div className={css.root}>
      <FieldCheckboxGroup
        name="usEligibility"
        id={formId ? `${formId}.us-eligibility-certified` : 'us-eligibility-certified'}
        optionLabelClassName={css.finePrint}
        options={[
          {
            key: 'us-citizen-located-in-usa',
            label: intl.formatMessage({ id: 'AuthenticationPage.usEligibilityCertificationText' }),
          },
        ]}
        validate={requiredFieldArrayCheckbox(
          intl.formatMessage({ id: 'AuthenticationPage.usEligibilityCertificationRequired' })
        )}
      />
    </div>
  );
};

export default UsEligibilityCertification;
